import { DepartmentsEnum } from '@moonpig/web-explore-types-graphql'

export const resolveDepartmentForResults = ({
  redirectedDepartment,
  isAllDepartmentUrl,
  urlDepartment,
}: {
  redirectedDepartment?: DepartmentsEnum
  isAllDepartmentUrl: boolean
  urlDepartment: DepartmentsEnum[]
}): DepartmentsEnum[] => {
  if (redirectedDepartment) {
    return [redirectedDepartment]
  }

  if (isAllDepartmentUrl) {
    return [DepartmentsEnum.ALL_CARDS]
  }

  return urlDepartment
}
